import type { JSX } from 'react'

// for the correct size of this icon, you must additionally set the size in the place of use for <Icon size={IconSocialSizes.googlePlay}
export const AmazonStoreIcon = (): JSX.Element => (
  <use href='#amazonStoreIcon' height='28px' width='96px' />
)
